module.exports = __webpack_public_path__ + "static/media/hiw1yellow.97e9f0d9.svg";